import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Grid } from '@material-ui/core';

function CustomTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    check,
    actions,
  } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {check ? (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
            />
          </TableCell>
        ) : (
          <Fragment />
        )}

        {headCells.map(headCell => (
          <TableCell
            style={{ fontSize: 12 }} //tamaño de fuente para el header de tabla
            key={headCell.id}
            align={headCell.align ? headCell.align : 'justify'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <Grid container justifyContent='space-between'
              onClick={createSortHandler(headCell.id)}
              style={{ cursor: 'pointer' }}
            >
              <Grid item xs="auto">
                {headCell.label}
              </Grid>
              <Grid item xs container justifyContent="flex-end">
                <TableSortLabel
                  style={{ justifyContent: 'flex-end' }}
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                //onClick={} aca estaba por defecto la funcion de ordenado
                >

                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span>
                  ) : null}
                </TableSortLabel>
              </Grid>


            </Grid>


          </TableCell>
        ))}

        {actions !== undefined ? (
          <TableCell align="center" style={{ fontSize: 12 }}>
            Acciones
          </TableCell>
        ) : null}
        {/* tamaño fuente acciones se cambia por separado */}
      </TableRow>
    </TableHead>
  );
}

export default CustomTableHead;

CustomTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
